import React, {Component} from 'react'
import AddCompany from '../AddCompany/Container'

class Home extends Component{

  componentDidMount(){
  }

  render(){
	  return (	    
		        <div>
		          <AddCompany />
		        </div>
	  )
  }

}
export default Home
